<template>
  <div>
    <div v-if="loading" class="w-full min-h-[500px] pb-5 flex flex-col gap-3">
      <CPreloader width="100%" height="48px" loading v-for="i in 20" :key="i" />
    </div>
    <div v-else>
      <div
        v-if="single"
        class="bg-white p-6 rounded-xl"
        :class="{ '!p-0': route?.meta?.layout === 'empty' }"
      >
        <h4 class="text-2xl leading-normal font-semibold text-dark-100">
          {{
            route?.meta?.layout === "empty"
              ? $t("privacy_policy")
              : $t("saraf_terms_and_conditions")
          }}
        </h4>
        <CCard
          class="static-text my-4 flex flex-col gap-3"
          v-html="single?.content"
        />
      </div>
      <CNodata
        v-else
        image="/images/svg/no-data/no-transaction.svg"
        :title="$t('no_results')"
        :subtitle="''"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import CCard from "@/components/Card/CardWrapper.vue";
import ApiService from "@/services/ApiService";
import CNodata from "@/components/Common/CNodata.vue";
import CPreloader from "@/components/CPreloader.vue";
import { useRoute } from "vue-router";

const loading = ref(false);
const route = useRoute();

const single = ref();

function getSingle() {
  loading.value = true;
  ApiService.get(`common/static/terms-conditions/`)
    .then((res) => {
      single.value = res.data;
    })
    .catch((e) => console.log(e.message))
    .finally(() => (loading.value = false));
}

getSingle();
</script>

<style>
.static-text > p {
  font-family: "Inter", sans-serif !important;
}
.static-text span {
  font-family: "Inter", sans-serif !important;
}
.static-text a,
.static-text a span {
  color: #0fd647 !important;
}
.static-text p,
.static-text li {
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.static-text ol,
.static-text ul {
  padding-left: 16px;
}
.static-text ul li {
  list-style: disc;
  position: relative;
}
.static-text ol li {
  list-style: auto;
}
.static-text a {
  color: #16cc53;
}
.static-text a:hover {
  text-decoration: underline;
}
.static-text img {
  width: 100%;
  max-height: 438px;
  border-radius: 8px;
}
.static-text b {
  font-weight: 500;
}

.static-text h4,
.static-text h1,
.static-text h2,
.static-text h3,
.static-text h5,
.static-text h6 {
  color: #080a15;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  margin-bottom: 12px;
}
</style>
